/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface LineGraphEdrLineAllOf
 */
export interface LineGraphEdrLineAllOf {
    /**
     * 
     * @type {string}
     * @memberof LineGraphEdrLineAllOf
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LineGraphEdrLineAllOf
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof LineGraphEdrLineAllOf
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof LineGraphEdrLineAllOf
     */
    'line_style': LineGraphEdrLineAllOfLineStyleEnum;
    /**
     * 
     * @type {string}
     * @memberof LineGraphEdrLineAllOf
     */
    'line_width': LineGraphEdrLineAllOfLineWidthEnum;
    /**
     * 
     * @type {string}
     * @memberof LineGraphEdrLineAllOf
     */
    'color': LineGraphEdrLineAllOfColorEnum;
    /**
     * 
     * @type {string}
     * @memberof LineGraphEdrLineAllOf
     */
    'symbol'?: LineGraphEdrLineAllOfSymbolEnum | null;
}

export const LineGraphEdrLineAllOfLineStyleEnum = {
    Solid: 'solid',
    Dashed: 'dashed'
} as const;

export type LineGraphEdrLineAllOfLineStyleEnum = typeof LineGraphEdrLineAllOfLineStyleEnum[keyof typeof LineGraphEdrLineAllOfLineStyleEnum];
export const LineGraphEdrLineAllOfLineWidthEnum = {
    Thin: 'thin',
    Regular: 'regular',
    Thick: 'thick'
} as const;

export type LineGraphEdrLineAllOfLineWidthEnum = typeof LineGraphEdrLineAllOfLineWidthEnum[keyof typeof LineGraphEdrLineAllOfLineWidthEnum];
export const LineGraphEdrLineAllOfColorEnum = {
    Blue: 'blue',
    Green: 'green'
} as const;

export type LineGraphEdrLineAllOfColorEnum = typeof LineGraphEdrLineAllOfColorEnum[keyof typeof LineGraphEdrLineAllOfColorEnum];
export const LineGraphEdrLineAllOfSymbolEnum = {
    Circle: 'circle',
    Diamond: 'diamond',
    Square: 'square',
    Triangle: 'triangle',
    TriangleDown: 'triangle-down'
} as const;

export type LineGraphEdrLineAllOfSymbolEnum = typeof LineGraphEdrLineAllOfSymbolEnum[keyof typeof LineGraphEdrLineAllOfSymbolEnum];


